import './header.css';
import toptower from '../../../static/notexttower.png';
import { Link } from 'react-router-dom'
import { headerType } from '../home';

const Header = ({signedIn, handleLogOut, param}) => {
    let buttonContainer;
    let authActionButton = (
        <Link to='/sign-in'>
            <button id='login'>Log in</button>
        </Link>
    )

    if (signedIn) {
        authActionButton = (
            <button id='login' onClick={() => handleLogOut()}>Log out</button>
        )
    } else {
        authActionButton = (
            <Link to='/sign-in'>
                <button id='login'>Log in</button>
            </Link>
        )
    }

    if (param === headerType.HOME) {
        buttonContainer =
            <div className="button-container">
                <Link to='/about'>
                    <button id='about'>About</button>
                </Link>
                {authActionButton}
            </div>
    } else if (param === headerType.UPLOAD || param === headerType.ABOUT) {
        buttonContainer =
            <div className="button-container">
                <Link to='/home'>
                    <button id='about'>Home</button>
                </Link>
                {authActionButton}
            </div>
    } else {
        buttonContainer =
            <div className="button-container">
                {authActionButton}
            </div>
    }

    return(
        <div className="header">
            <a href="">
                <div className="logo-container">
                    <img id="logo" src={toptower} alt="HuaPsych"/>
                    <p id="header_text">Hua Psych</p>
                </div>
            </a>
            {buttonContainer}
        </div>
    )
}

export default Header;